import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function GenericContact({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        fillRule="evenodd"
        d="M11.9999 2.66671C6.84526 2.66671 2.66659 6.84538 2.66659 12C2.66659 13.8546 3.20748 15.5828 4.14012 17.0355C6.14032 15.5604 8.93823 14.6667 11.9999 14.6667C15.0616 14.6667 17.8595 15.5604 19.8597 17.0355C20.7924 15.5828 21.3333 13.8546 21.3333 12C21.3333 6.84538 17.1546 2.66671 11.9999 2.66671ZM11.9999 21.3334C9.17879 21.3334 6.65 20.0817 4.93859 18.1034C6.67601 16.8252 9.18062 16 11.9999 16C14.8192 16 17.3238 16.8252 19.0613 18.1034C17.3498 20.0817 14.821 21.3334 11.9999 21.3334ZM1.33325 12C1.33325 6.109 6.10888 1.33337 11.9999 1.33337C17.891 1.33337 22.6666 6.109 22.6666 12C22.6666 17.8911 17.891 22.6667 11.9999 22.6667C6.10888 22.6667 1.33325 17.8911 1.33325 12ZM11.9999 5.33337C10.159 5.33337 8.66659 6.82576 8.66659 8.6667V10C8.66659 11.841 10.159 13.3334 11.9999 13.3334C13.8409 13.3334 15.3333 11.841 15.3333 10V8.66671C15.3333 6.82576 13.8409 5.33337 11.9999 5.33337ZM9.99992 8.6667C9.99992 7.56214 10.8953 6.66671 11.9999 6.66671C13.1045 6.66671 13.9999 7.56214 13.9999 8.66671V10C13.9999 11.1046 13.1045 12 11.9999 12C10.8953 12 9.99992 11.1046 9.99992 10V8.6667Z"
        fill={iconColor}
      />
    </Svg>
  );
}
